import { render } from "./detailsOrde.vue?vue&type=template&id=46ea00aa&scoped=true"
import script from "./detailsOrde.vue?vue&type=script&lang=js"
export * from "./detailsOrde.vue?vue&type=script&lang=js"

import "./detailsOrde.vue?vue&type=style&index=0&id=46ea00aa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46ea00aa"]])

export default __exports__